export enum StatusType {
    OPEN = 'open',
    PENDING = 'pending',
    CLOSED = 'closed',
}
